import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
// https://github.com/mui/material-ui/issues/30591
// Note that this version is from the 7.0.0 ALPHA
export class Adapter extends AdapterLuxon {
  getWeekdays = () => ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

  getWeekArray = (date) => {
    const cleanValue = this.setLocaleToValue(date);
    const firstDay = this.startOfWeek(this.startOfMonth(cleanValue));
    const lastDay = this.endOfWeek(this.endOfMonth(cleanValue));

    const { days } = lastDay.diff(firstDay, 'days').toObject();

    const weeks = [];
    new Array(Math.round(days ?? 0))
      .fill(0)
      .map((_, i) => i)
      .map((day) => firstDay.plus({ days: day }))
      .forEach((v, i) => {
        if (i === 0 || (i % 7 === 0 && i > 6)) {
          weeks.push([v]);
          return;
        }

        weeks[weeks.length - 1].push(v);
      });

    return weeks;
  };

  startOfWeek = (value) => value.startOf(
    'week',
    { useLocaleWeeks: true },
  );

  endOfWeek = (value) => value.endOf(
    'week',
    { useLocaleWeeks: true },
  );
}
